export default "__VITE_ASSET__8KK$Gqa7__"